/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientsTkEnrolmentPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
    enrolTk: boolean;
}
export const PatientsTkEnrolmentPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsTkEnrolmentPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsTkEnrolmentPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsTkEnrolmentPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsTkEnrolmentPermissions_enrolTk_Validators: ValidatorFn[] =
    [  Validators.required, ];


